import { render } from "./TimeDepositsPage.vue?vue&type=template&id=44b23e08"
import script from "./TimeDepositsPage.vue?vue&type=script&lang=js"
export * from "./TimeDepositsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__